// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__ClBu3","box":"Navbar_box__IdYE1","logo":"Navbar_logo__hAgkd","text":"Navbar_text__9yBYT","list":"Navbar_list__dcRHU","item":"Navbar_item__EP-Oy"};